import React from "react";
import SignalBadge from "../signals/SignalBadge";
import { resolveDisplayState } from "../signals/signalDisplay";
import { useGridCellFocusClassName, useGridCellSelectionClassName } from "../state/GridStateContext";
import { joinClassNames } from "../utils/classNames";

const GRID_CELL_SELECTED_CLASS = "grid-core-cell-selected";

function formatDisplayValue(value, placeholder) {
    if (value === null || value === undefined || value === "") return placeholder;
    return value;
}

function LightCell({
    value,
    signals = [],
    placeholder = "-",
    className,
    title,
    rowId,
    rowIndex,
    columnKey,
    columnIndex,
    focusClassName,
}) {
    const displayState = resolveDisplayState(signals);
    const displayValue = formatDisplayValue(value, placeholder);
    const cellIdentity = { rowId, rowIndex, columnKey, columnIndex };
    const resolvedSelectionClassName = useGridCellSelectionClassName(cellIdentity, GRID_CELL_SELECTED_CLASS);
    const resolvedFocusClassName = useGridCellFocusClassName(cellIdentity, focusClassName);

    return (
        <div
            className={joinClassNames(
                "grid-core-light-cell",
                displayState.hasSignals && "grid-core-light-cell-signaled",
                `grid-core-light-cell-severity-${displayState.severity}`,
                className,
                resolvedSelectionClassName,
                resolvedFocusClassName,
            )}
            title={title || (typeof displayValue === "string" || typeof displayValue === "number" ? String(displayValue) : undefined)}
        >
            <span className="grid-core-light-cell-value">{displayValue}</span>
            <SignalBadge signals={displayState.signals} />
        </div>
    );
}

function areLightCellPropsEqual(previous, next) {
    return (
        Object.is(previous.value, next.value) &&
        previous.signals === next.signals &&
        previous.placeholder === next.placeholder &&
        previous.className === next.className &&
        previous.title === next.title &&
        previous.rowId === next.rowId &&
        previous.rowIndex === next.rowIndex &&
        previous.columnKey === next.columnKey &&
        previous.columnIndex === next.columnIndex &&
        previous.focusClassName === next.focusClassName
    );
}

export default React.memo(LightCell, areLightCellPropsEqual);
